import axios from "axios";
import { BASE_URL, CONTENT_TYPE } from "../constants";

async function Delete(path, token, paramObj, contentType = CONTENT_TYPE.JSON) {
  try {
    const url = `${BASE_URL}${path}`;
    const headers = {
      "Content-Type": contentType,
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const config = {
      headers,
      ...(paramObj && { params: paramObj }),
    };

    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/signin?error_code=session_expired";
      console.log("SESSION EXPIRED");
    }
    throw error;
  }
}

export { Delete };
